import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hideNavigationItemDefaultErrorFlagTitle: {
		id: 'navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-title',
		defaultMessage: "Something's gone wrong",
		description: 'Flag title when hiding a view fails with a generic error.',
	},
	hideNavigationItemDefaultErrorFlagDescription: {
		id: 'navigation-kit-hide-item-service.services.hide-navigation-item-default-error-flag-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Flag description when hiding a view fails with a generic error.',
	},
	userNotLoggedInErrorFlagTitle: {
		id: 'navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-title',
		defaultMessage: "You'll need to log in",
		description:
			'Flag title when the request to hide the view has failed due to the user not being logged in.',
	},
	userNotLoggedInErrorFlagDescription: {
		id: 'navigation-kit-hide-item-service.services.user-not-logged-in-error-flag-description',
		defaultMessage:
			'You need to be logged in to manage the navigation. Please log in and try again.',
		description:
			'Flag description when the request to hide the view has failed due to the user not being logged in.',
	},
	userNotAdminErrorFlagTitle: {
		id: 'navigation-kit-hide-item-service.services.user-not-admin-error-flag-title',
		defaultMessage: "You don't have permission",
		description:
			'Flag title when the request to hide the view has failed due to the user not being allowed.',
	},
	userNotAdminErrorFlagDescription: {
		id: 'navigation-kit-hide-item-service.services.user-not-admin-error-flag-description',
		defaultMessage: 'You are not allowed to manage the navigation.',
		description:
			'Flag description when the request to hide the view has failed due to the user not being allowed.',
	},
	viewNotFoundErrorFlagTitle: {
		id: 'navigation-kit-hide-item-service.services.view-not-found-error-flag-title',
		defaultMessage: 'This tab has been removed',
		description:
			'Flag title when the request to hide the view has failed due to the tab not being found.',
	},
	viewNotFoundErrorFlagDescription: {
		id: 'navigation-kit-hide-item-service.services.view-not-found-error-flag-description',
		defaultMessage: "The tab you're trying to remove can't be found.",
		description:
			'Flag description when the request to hide the view has failed due to the tab not being found.',
	},
});
